const $ = require('cash-dom');
const Cookie = require('js-cookie');
const Page = require('../components/page');

const LanguageAndCurrencySelectors = {
  init() {
    $('#header_languages .selected').on('click', function () {
      $('#header_currencies').removeClass('opened');
    });

    $('#header_currencies .selected').on('click', function () {
      $('#header_languages').removeClass('opened');
    });

    $('#footer_currencies, #header_currencies').on('change', function (e, value) {
      Cookie.set('chosen-currency', value, {
        expires: 31,
        path: '/',
        domain: '.' + window.location.host.replace(/^(\w{2,3}\.)?(.+)/, '$2')
      });

      location.reload();
    });

    //TODO: return if needed
    /*$('#header_languages').on('change', function (e, value) {
      if (value === 'en') {
        value = 'www';
      }

      var url = location.href;
      url = url.replace(/:\/\/\w{2,3}\./, '://' + value + '.');
      window.location.replace(decodeURI(url));
    });*/

    //append needed GET params to Languages links
    let params = Page.getSearchParameters();

    $('#header_languages .option').each(function () {
      let option = $(this),
        href = option.attr('href');

      if (typeof href !== 'undefined' && href.length) {
        for (let param in params) {
          if (params.hasOwnProperty(param) && href.indexOf(param) === -1) {
            if (href.indexOf('?') === -1) {
              href += '?';
            } else {
              href += '&';
            }

            href += param + '=' + params[param];
          }
        }

        option.attr('href', href);
      }
    });
  },
};

module.exports = LanguageAndCurrencySelectors;
